import React from "react";
import { BusinessPortalHeader } from "src/components";
import OrganisationsTable from "./components/OrganisationsTable";

const TablePage = ({
    user,
    donationList,
    isFetchingDonationList,
    handleEditDonation,
    handleCreateDonation,
    handleShowDeleteDialog,
    handleCheckDonation,
    handleCheckAllDonations,
    allDonationsChecked,
    checkedDonations
}) => {

    return (
        <>
            <BusinessPortalHeader
                title="Donations"
                description="Create and manage donation opportunities for your business within the Me Business app. Upload an organisation's logo, provide details about the cause, and include a link or button to direct users to the donation page. Engage your users in supporting meaningful causes through your platform."
                maxWidth="94.5rem"
            />

            <OrganisationsTable
                user={user}
                donationList={donationList}
                isFetching={isFetchingDonationList}
                allDonationsChecked={allDonationsChecked}
                handleCheckAllDonations={handleCheckAllDonations}
                checkedDonations={checkedDonations}
                handleCheckDonation={handleCheckDonation}
                handleEditDonation={handleEditDonation}
                handleCreateDonation={handleCreateDonation}
                handleShowDeleteDialog={handleShowDeleteDialog}
            />
        </>
    );
};

export default TablePage;
